import { onlineManager } from '@tanstack/react-query';
import { WifiOff } from 'lucide-react';
import { useSyncExternalStore, type ReactElement } from 'react';

// Aviso de conexión (QA F1 #8, UX-UI §1.3): fijo arriba del contenido mientras no
// hay red, sin bloquear la pantalla. La fuente es el onlineManager de TanStack Query
// (escucha online/offline del navegador), el mismo que dispara la recarga al volver.

const subscribe = (cb: () => void): (() => void) => onlineManager.subscribe(cb);
const isOnline = (): boolean => onlineManager.isOnline();

export function OfflineBanner(): ReactElement {
  const online = useSyncExternalStore(subscribe, isOnline, () => true);
  // La región viva está siempre montada y solo cambia su contenido: un lector de
  // pantalla no anuncia una región que aparece ya con texto (adversarial P4.1 B4).
  return (
    <div className="net-live" role="status">
      {!online && (
        <div className="net-banner">
          <WifiOff size={16} aria-hidden="true" />
          <span>
            <strong>Sin conexión a internet.</strong> La pantalla se actualiza al volver la
            conexión.
          </span>
        </div>
      )}
    </div>
  );
}
